import React from "react";
import { parseHtml } from "@/utils/common";

interface ConclusionProps {
  title: string;
  text: string;
}

const Conclusion: React.FC<ConclusionProps> = ({ title, text }) => (
  <section
    id="muted-cta"
    className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[90px] bg-white before:content-[''] before:absolute before:h-[100%] before:inset-0 before:bg-[url('/images/client-bg.png')] before:bg-no-repeat before:bg-[length:100%_100%] before:bg-center before:bg-[#F0F8FF] before:-z-10"
  >
    <div className="container max-w-[1020px] mx-auto ">
      <div className="heading ">
        <h2 className="font-bold text-heading-5  text-primary-text mb-[24px]">
          {title}
        </h2>
        <p className="text-subtitle-2 text-left font-regular  text-primary-text">
          {parseHtml(text)}
        </p>
      </div>
    </div>
  </section>
);

export default Conclusion;
